import { Component, OnInit, inject } from '@angular/core';
import { P500Component } from '@nimmsta/ng-commons-lib/error-pages';
import { ProductFruitsService } from '../../services/productfruits.service';

@Component({
  selector: 'app-p500-ext',
  template: '<app-p500></app-p500>',
  imports: [P500Component],
})
export class P500ExtComponent extends P500Component implements OnInit {
  private productFruits = inject(ProductFruitsService);

  ngOnInit(): void {
    this.productFruits.destroy();
  }
}
